// realPrice on a cart line is the line's own unit price before any discount, in the till's
// pricing basis: tax-inclusive when the line is priced tax-included, tax-exclusive otherwise.
// cart.js recomputes a line from realPrice (qty edit, line click, bill discount apply/remove)
// and, on a tax-exclusive line, adds tax on top of it. A retrieved line (Advance / Layaway /
// Credit Sale) must therefore get a tax-exclusive realPrice on a tax-exclusive till, or the
// first recompute adds the tax a second time (Chocolala 160 + 5% = 168 became 176.40).
//
// taxIncludedPrice is the BUG-1558 pre-discount price with tax (useOrderHistory
// preDiscountUnitPrice). It is returned unchanged for a tax-included line.
export const resolveRetrievedRealPrice = (pro, { taxIncluded, taxIncludedPrice, taxRate, precision = 2 }) => {
  if (taxIncluded) return taxIncludedPrice;
  const qty = Number(pro?.qty) || 0;
  if (!(Number(pro?.discount) > 0) && qty > 0 && pro?.linenet != null) {
    return Number(pro.linenet) / qty;
  }
  const rate = Number(taxRate) || 0;
  if (pro?.grossstd) {
    return parseFloat((Number(pro.grossstd) / (1 + rate / 100)).toFixed(precision));
  }
  return pro?.netunit || 0;
};
